module.exports = __webpack_public_path__ + "static/img/top.eb22dfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vcard/top.jpg
// module id = kIv6
// module chunks = 1